import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Toast from "../components/Toast";


  function Index(props) {

  function renderToast() {
    let { showToast, error, message } = props;
    return <Toast show={showToast} message={message} success={!error} />
  }

    return (
      <Fragment>
        {renderToast()}
        {props.children}
      </Fragment>
    );
  }
 
function mapStateToProps(store) {
  return {
    showToast: store.global.showToast,
    error: store.global.error,
    message: store.global.message
  };
}

export default withRouter(connect(mapStateToProps)(Index));
